var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#9E120E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2178 14.9017L15.7361 14.7325C15.5619 14.7121 15.3853 14.7314 15.2196 14.7889C15.0539 14.8465 14.9034 14.9409 14.7794 15.065L13.7061 16.1384C12.0501 15.2962 10.7041 13.9502 9.86193 12.2942L10.9411 11.215C11.1919 10.9642 11.3144 10.6142 11.2736 10.2584L11.1044 8.78836C11.0714 8.5038 10.9348 8.24133 10.7207 8.05094C10.5067 7.86054 10.2301 7.75552 9.9436 7.75586H8.93443C8.27527 7.75586 7.72693 8.30419 7.76777 8.96336C8.07693 13.945 12.0611 17.9234 17.0369 18.2325C17.6961 18.2734 18.2444 17.725 18.2444 17.0659V16.0567C18.2503 15.4675 17.8069 14.9717 17.2178 14.9017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.86a83c3469cc89de0933f1bb0fdd73bc.svg";
export { ForwardRef as ReactComponent };